module.exports = __webpack_public_path__ + "static/img/15.5df6313.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/15.png
// module id = r3s9
// module chunks = 0